import * as React from 'react'

function SvgCrackIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M7.5 8 18 4l-2 3 4.5.5-6.5 6 4 1L5.5 20l4.5-6H4l8-5-4.5-1Z"
        stroke="#E91630"
      />
    </svg>
  )
}

export default SvgCrackIcon
